import { supabase } from "@/integrations/supabase/client";

export interface SendPrivateNotificationParams {
  targetUserId: string;
  title: string;
  message: string;
}

export interface PrivateNotificationResponse {
  success: boolean;
  message: string;
  notification_id?: string;
  recipient_id?: string;
}

/**
 * Envía una notificación privada de admin a un usuario específico
 */
export const sendPrivateNotification = async (
  params: SendPrivateNotificationParams
): Promise<PrivateNotificationResponse> => {
  try {
    const { data, error } = await supabase.rpc('admin_send_private_notification', {
      p_target_user_id: params.targetUserId,
      p_title: params.title,
      p_message: params.message
    });

    if (error) throw error;

    return data as unknown as PrivateNotificationResponse;
  } catch (error) {
    console.error('Error sending private notification:', error);
    throw error;
  }
};

/**
 * Busca usuarios para el selector de destinatarios
 */
export const searchUsersForNotification = async (
  searchTerm: string
): Promise<Array<{ id: string; full_name: string; email: string }>> => {
  try {
    const { data, error } = await supabase.rpc('admin_search_users', {
      search_term: searchTerm
    });

    if (error) throw error;

    return data || [];
  } catch (error) {
    console.error('Error searching users:', error);
    return [];
  }
};
